import React from 'react';
import Icon from '../../shared/Icon';
import './AlertSteps.css';

/**
 * Why the step will not advance yet, in the author's words.
 *
 * **A disabled button with no explanation is the failure this fixes.** The
 * reasons were being computed and thrown away, so an author who picked a
 * comparison and a threshold but left the table name blank saw a greyed-out
 * Next and no indication of what was missing. The recipients step already
 * states its own blocker inline; this is the same courtesy for the spec.
 *
 * Silent while there is nothing to say, so it never occupies space on a
 * complete form.
 */
const AlertSpecProblems = ({ problems = [], heading = 'Not ready yet' }) => {
  if (problems.length === 0) return null;

  return (
    <div className="resui-banner resui-banner--alert alert-inline-block">
      <Icon name="warning_amber" />
      {/* A div, not a span: `<ul>` is flow content and cannot legally sit inside
          phrasing content. Browsers tolerate it, but they are not obliged to
          agree on how, and the banner class works on either element. */}
      <div className="resui-banner-text">
        <strong>{heading}</strong>
        <ul className="alert-problem-list">
          {problems.map((problem) => (
            <li key={problem}>{problem}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AlertSpecProblems;
